document.addEventListener("DOMContentLoaded", function (event) {
    /********************************
     * Global link
     *******************************/
    const ttml = document.querySelector('html');
    const body = document.querySelector('body');

    /********************************
     * Upsell
     *******************************/
    let upsellCarousel = document.querySelector('#up-upsell-carousel');
    let countTry = 0;

    const startInterval = () => {
        interval = setInterval(() => {
            try {
                countTry++;
                upsellCarousel = document.querySelector('#up-upsell-carousel');

                if (countTry > 5) {
                    clearInterval(interval);
                }

                if (!upsellCarousel) {
                    throw new Error('up-upsell-carousel section is not defined');
                }

                clearInterval(interval);
                implementRatingUpsell();

            } catch (error) {
                console.error(error)
            }
        }, 1000);
    };
    startInterval();

    const initRecommendSlider = () => {
        new Swiper("#upsell-swiper-carousel", {
            slidesPerView: "auto",
            spaceBetween: 15,
            //loop: true,
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            },
            breakpoints: {
                767: {
                    spaceBetween: 20,
                }
            }
        });
    }

    /******** Cart Drawer - rating ********/
    const HTTPRequest = async (url) => {
        const respons = await fetch(`https://www.nutrex-hawaii.com/${url}.js`);
        if (!respons.ok) {
            throw new Error(respons.status)
        }
        return await respons.json();
    }

    const implementRatingUpsell = async () => {
        const upsellCarouselItems = Array.from(document.querySelectorAll('#up-upsell-carousel ul.slider li'));
        upsellCarouselItems.forEach(async (slide) => {
            const link = slide.querySelector('a.variationStrong');
            const linkURL = link.getAttribute('href').split('?')[0];
            const requestResults = await HTTPRequest(linkURL);

            const carouselTile = slide.querySelector('.UpcartDesignSettings__cartTextColor');
            carouselTile.insertAdjacentHTML('afterend', `
              <span class="stamped-product-reviews-badge stamped-main-badge" data-id="${requestResults.id}"  data-product-sku="${requestResults.variants[0].sku}"
                    data-product-title="${requestResults.title}" data-product-type="" style="display: block;"></span>`);
        });

        setTimeout(() => {
            if (body.classList.contains('cart')) {
                duplicateAndTransferSlides();
                updateShippingProgress();
            }

            StampedFn.reloadUGC();
        }, 500);
    };

    /******** Copy upsell product ********/
    const duplicateAndTransferSlides = () => {
        const upsellCarouselItems = document.querySelectorAll('#up-upsell-carousel ul.slider li');
        const upsellSwiperCarousel = document.querySelector('#upsell-swiper-carousel .swiper-wrapper');

        if (upsellSwiperCarousel) {
            const clonedItems = Array.from(upsellCarouselItems).map(item => {
                item.classList.add('swiper-slide')
                return item.cloneNode(true);
            });

            upsellSwiperCarousel.append(...clonedItems);
            initRecommendSlider();
            triggerForAddToCart();
        }
    }

    /******** page cart: trigger button add to cart ********/
    const triggerForAddToCart = () => {
        const pageCarouselWrap = document.querySelector('#upsell-swiper-carousel');

        pageCarouselWrap.addEventListener('click', (event) => {
            const target = event.target;

            if(target.classList.contains('upcart-upsells-button')){
                event.preventDefault();
                const swiperSlide = target.closest('.swiper-slide');
                const hrefProduct = swiperSlide.querySelector('a.variationStrong').getAttribute('href');

                const drawerSlideLink = document.querySelector('#up-upsell-carousel ul.slider .slide a[href="'+hrefProduct+'"]');
                const drawerLinkSlide = drawerSlideLink.closest('.slide');
                drawerLinkSlide.querySelector('.upcart-upsells-button').click();
                setTimeout(() => location.reload(true), 500);
            }
        });
    }

    /******** shipping ********/
    const updateShippingProgress = () => {
        const shippingProgress = document.querySelector('#shipping-progress');
        const shippingPrice = document.querySelector('#shipping-progress-wrap .shipping-price');
        const shippingFree = document.querySelector('#shipping-progress-wrap .shipping-free');
        const subtotalPriceText = document.querySelector('#subtotal-value').textContent;

        if (!subtotalPriceText) {
            return;
        }

        const subtotalPrice = parseFloat(subtotalPriceText.replace(/[^\d.]/g, ''));
        const minAmountText = window.upcartSettings.upcartEditorSettings.rewardsTiers.tiers[0].minAmount;
        const minAmount = parseFloat(minAmountText.replace(',', '.'));
        const filledPercentage = Math.max(0, ((minAmount - subtotalPrice) / minAmount) * 100);

        shippingProgress.style.width = `${(100 - filledPercentage).toFixed(2)}%`;

        if ((minAmount - subtotalPrice) > 0) {
            const remainingAmount = (minAmount - subtotalPrice).toFixed(2);
            shippingPrice.querySelector('.upcart-rewards-price').innerHTML = remainingAmount.toString();
            shippingPrice.style.display = 'block';
            shippingFree.style.display = 'none';
        } else {
            shippingPrice.style.display = 'none';
            shippingFree.style.display = 'block';
        }
    };

    /******** tracking items in cart ********/
    const config = {childList: true, subtree: true, attributes: true};
    const clazzObserver = document.querySelector('.page-cart');

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.target.classList.contains('is-empty')) {
                body.classList.add('cart-empty')
            }
        });
    });

    window.upcartOnAddToCart = () => {
        setTimeout(() => implementRatingUpsell(), 300);
    }

    window.addEventListener('click', ({target}) => {
        if (target.closest('.cart-item__quantity')) {
            setTimeout(() => updateShippingProgress(), 1000);
            observer.observe(clazzObserver, config);
        }
    });
    
    /******** Category tiles carousel ********/
    new Swiper('#category-tiles-swiper', {
        slidesPerView:'auto',
        spaceBetween: 10,
        freeMode: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
          1440: {
            slidesPerView:'7',
            spaceBetween: 15,
            pagination: false,
          }
        },
    });
});


